import {Injectable} from '@angular/core';
import {TenantService} from './tenant.service';
import {first, map} from 'rxjs/operators';
import {findUniqueMatchWithId, readCollectionWithIds} from '../common/firestore-utils';
import {CourseCoupon} from '../models/coupon.model';
import {from, Observable} from 'rxjs';
import { Firestore, QueryConstraint, collection, collectionData, doc, orderBy, query, setDoc, updateDoc, where } from '@angular/fire/firestore';


@Injectable({
  providedIn: 'root'
})
export class CourseCouponsDbService {


  constructor(private tenant: TenantService,
              private firestore: Firestore) {

  }


  findCouponByCode(courseId:string, code:string): Observable<CourseCoupon> {

    const constraints = [
      where('code', '==', code)
    ]

    const courseQuery$ = collectionData(query(collection(this.firestore, this.courseCouponsPath(courseId)), ...constraints), {idField: "id"}) as Observable<CourseCoupon[]>;
    
    return (findUniqueMatchWithId(courseQuery$) as Observable<CourseCoupon>)
      .pipe(
        first(),
        map(coupon => {return coupon? {...coupon, courseId} : null})
      );
  }

  loadCoupons(courseId: string, activeCouponsOnly: boolean) {

    const constraints: QueryConstraint[] = [
      orderBy('created', 'desc')
    ]
    
    if (activeCouponsOnly) {
      constraints.push(where('active', '==', true))
    }

    const query$ = query(
      collection(this.firestore,
        this.courseCouponsPath(courseId)),
        ...constraints  
    )

    const queryData$ = collectionData(query$, {idField: "id"}) as Observable<CourseCoupon[]>;

    return readCollectionWithIds<CourseCoupon[]>(
      queryData$
    )
      .pipe(
        map(coupons => coupons.map(coupon => {return {...coupon, courseId}}))
      );
  }

  private courseCouponsPath(courseId: string) {
    return this.tenant.path(`courses/${courseId}/coupons`);
  }


  createNewCoupon(courseId: string, coupon: CourseCoupon) {

    const addCouponDocRef = doc(this.firestore, this.courseCouponsPath(courseId) + `/${coupon.id}`)
    const addCouponAsync = setDoc(addCouponDocRef,coupon);

    return from(addCouponAsync)
      .pipe(
        map(ref => {
            return {
              ...coupon
            };
          })
      );

  }

  saveCoupon(courseId: any, couponId:string, props: Partial<CourseCoupon>): Observable<any> {

    const saveCouponDocRef = doc(this.firestore, this.courseCouponsPath(courseId), couponId)

    const updateDocAsync = updateDoc(saveCouponDocRef, props)

    return from(updateDocAsync)

  }

}
